import api from "../utils/api";
import { isGuid } from "../utils/string";
import {
  LOGOUT
} from "./types";

export const save = (
    {
        uuid,
        representationDate,
        terminationDate,
        terminationStyle,
        retainer,
        retainerAsOf,
        minutes,
        assignedToUuid,
        billedTime,
        billedExpenses,
        writeOffs,
        trust,
        due,
        lastInvoiced,
        rates,
        ratesReviewed,
        meta
    }) => async (dispatch) => {
        try {
            const res = await api.post(`/clients`, {
                uuid,
                representationDate,
                terminationDate,
                terminationStyle,
                retainer,
                retainerAsOf,
                minutes,
                assignedToUuid,
                billedTime,
                billedExpenses,
                writeOffs,
                trust,
                due,
                lastInvoiced,
                rates,
                ratesReviewed,
                meta
            });
            return res.data;
        } catch (error) {
            dispatch({
                type: LOGOUT
            });
        }
    }

export const destroy = ({ uuid }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.delete(`/clients/i/${uuid}`) : { data: { success: false }} ;
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) {
            dispatch({
                type: LOGOUT
            });
            return;
        }

        return err?.response?.data || {
            success: false,
            error: {
                message: "The client profile could not be removed."
            }
        };
    }
}

export const get = ({ uuid }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.get(`/clients/i/${uuid}`) : { data: { success: false }} ;
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) {
            dispatch({
                type: LOGOUT
            });
            return;
        }

        return err?.response?.data || {
            success: false,
            error: {
                message: "The client profile could not be loaded."
            }
        };
    }
}
